// 60-language BCP-47 catalog for the browser SpeechRecognition API.
// Chrome / Edge / Safari all accept these. Firefox has no SR at all — the mic hides.
// Sorted so the most common India + world languages are near the top.
export const VOICE_LANGUAGES = [
  { code: "auto",   label: "Auto-detect (browser default)" },
  { code: "en-IN",  label: "English (India)" },
  { code: "en-US",  label: "English (US)" },
  { code: "en-GB",  label: "English (UK)" },
  { code: "hi-IN",  label: "हिन्दी · Hindi" },
  { code: "bn-IN",  label: "বাংলা · Bengali" },
  { code: "ta-IN",  label: "தமிழ் · Tamil" },
  { code: "te-IN",  label: "తెలుగు · Telugu" },
  { code: "mr-IN",  label: "मराठी · Marathi" },
  { code: "gu-IN",  label: "ગુજરાતી · Gujarati" },
  { code: "kn-IN",  label: "ಕನ್ನಡ · Kannada" },
  { code: "ml-IN",  label: "മലയാളം · Malayalam" },
  { code: "pa-IN",  label: "ਪੰਜਾਬੀ · Punjabi" },
  { code: "ur-IN",  label: "اردو · Urdu" },
  { code: "ne-NP",  label: "नेपाली · Nepali" },
  { code: "si-LK",  label: "සිංහල · Sinhala" },
  { code: "es-ES",  label: "Español (España)" },
  { code: "es-MX",  label: "Español (México)" },
  { code: "es-US",  label: "Español (US)" },
  { code: "pt-BR",  label: "Português (Brasil)" },
  { code: "pt-PT",  label: "Português (Portugal)" },
  { code: "fr-FR",  label: "Français" },
  { code: "fr-CA",  label: "Français (Canada)" },
  { code: "de-DE",  label: "Deutsch" },
  { code: "it-IT",  label: "Italiano" },
  { code: "nl-NL",  label: "Nederlands" },
  { code: "sv-SE",  label: "Svenska" },
  { code: "da-DK",  label: "Dansk" },
  { code: "nb-NO",  label: "Norsk" },
  { code: "fi-FI",  label: "Suomi" },
  { code: "pl-PL",  label: "Polski" },
  { code: "ru-RU",  label: "Русский" },
  { code: "uk-UA",  label: "Українська" },
  { code: "tr-TR",  label: "Türkçe" },
  { code: "ar-SA",  label: "العربية (Saudi)" },
  { code: "ar-AE",  label: "العربية (UAE)" },
  { code: "ar-EG",  label: "العربية (Egypt)" },
  { code: "fa-IR",  label: "فارسی · Persian" },
  { code: "he-IL",  label: "עברית · Hebrew" },
  { code: "el-GR",  label: "Ελληνικά" },
  { code: "cs-CZ",  label: "Čeština" },
  { code: "sk-SK",  label: "Slovenčina" },
  { code: "ro-RO",  label: "Română" },
  { code: "hu-HU",  label: "Magyar" },
  { code: "bg-BG",  label: "Български" },
  { code: "hr-HR",  label: "Hrvatski" },
  { code: "sr-RS",  label: "Српски" },
  { code: "zh-CN",  label: "中文 · Mandarin (Simplified)" },
  { code: "zh-TW",  label: "中文 · Mandarin (Traditional)" },
  { code: "yue-HK", label: "廣東話 · Cantonese" },
  { code: "ja-JP",  label: "日本語" },
  { code: "ko-KR",  label: "한국어" },
  { code: "th-TH",  label: "ไทย · Thai" },
  { code: "vi-VN",  label: "Tiếng Việt" },
  { code: "id-ID",  label: "Bahasa Indonesia" },
  { code: "ms-MY",  label: "Bahasa Melayu" },
  { code: "fil-PH", label: "Filipino" },
  { code: "sw-KE",  label: "Kiswahili" },
  { code: "am-ET",  label: "አማርኛ · Amharic" },
  { code: "af-ZA",  label: "Afrikaans" },
  { code: "zu-ZA",  label: "isiZulu" },
];
